
import { Component, Vue } from "vue-property-decorator";
import HouseMin from "@/components/HouseMin.vue";
import { searchHousePlan } from "@/api/HomePage";
import { ShortRent } from "@/enum/index";

interface Picture {
  url: string;
}

interface Houseplan {
  buildingName: string;
  buildingArea: string;
  isShortRent: ShortRent;
  area: number;
  flower: string;
  firstPictureVOS: Picture;
  [propName: string]: string | number | object;
}

@Component
export default class BoutiqueHouse extends Vue {
  private houseplans: Array<Houseplan> | [] = [];

  async mounted() {
    const houseplans = await searchHousePlan({
      boutique: 1,
      hasImage: true
    });
    this.houseplans = houseplans.data.body.rows.slice(0, 6).map(item => ({
      ...item,
      imgUrl: item.firstPictureVOS
        ? item.firstPictureVOS.url
        : item.ossVOS[0].url
    }));
    console.log(this.houseplans);
  }
  render() {
    return (
      <div class="boutique-house">
        <h2 class="title">精品房源</h2>
        <div style="height:10px;"></div>
        <a-row>
          {this.houseplans.map((houseplan: Houseplan, idx) => (
            <a-col key={idx} span={8} style="padding:0px 20px;">
              <HouseMin houseplan={houseplan}></HouseMin>
            </a-col>
          ))}
        </a-row>
        <div style="height:10px;"></div>
        <a-button class="ty-btn-ghost" ghost style="border-radius:18px;">
          更多房源 &gt;
        </a-button>
      </div>
    );
  }
}
